import Colors from "../../../template/Colors";

const styles = {
  container: {
    background: '#F5F5F5',
  },
  tableContainer: {
    overflow: 'auto',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    margin: '16px',
    height: 'calc(100vh - 183px)',
    background: "#fff"
  },
  dialogPaper: {
    maxWidth: "540px",
    maxHeight: "340px",
    height: "100%",
    overflow: 'hidden',
  },
  modalHeader: {
    minHeight: 64,
    padding: "0px 32px",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    justifyContent: "space-between",
    "& >div": {
      height: "100%",
    }
  },
  titleModal: {
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "27px",
    color: Colors.commons.secondary,
    alignContent: 'center'
  },
  buttonClose: {
    width: 32,
    height: 32,
    background: "#FB7676",
    borderRadius: "100px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      background: Colors.commons.darkRed,
    },
    "& svg": {
      color: "#fff",
    },
  },
  toggleButtons: {
    margin: "8px 24px",
  },
  inputRetangular: {
    borderRadius: "8px",
  },
  contentField: {
    display: "flex",
    flexDirection: "column",
    width: "90%",
  },
  contentFieldAtivo: {
    display: "flex",
    flexDirection: "column",
    width: "10%",
  },
  titleField: {
    color: "#868686",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    marginBottom: "4px",
  },
  contentInformacoesMotivoCancelamento: {
    display: "flex",
    flexDirection: "column",
    height: "100%",

  },
  footer: {
    display: "flex",
    flexDirection: "row",
    padding: "0px 24px",
    gap: "10px",
    height: "69px",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
    alignItems: "center",
  },
  buttonCancelar: {
    color: Colors.commons.gray9,
    cursor: "pointer",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    fontWeight: 700,
  },
  contentModal: {
    height: 'calc(100% - 48px)',
  },
  switchRoot: {
    marginLeft: '-10px'
  },
  switchBase: {
    height: 'fit-content'
  },
  contentFields: {
    padding: "0 24px",
    height: "100%",
    display: "flex",
    gap: "16px",
  },
  containerModal: {
    height: "100%",
  },
  buttonCriar: {
    position: 'absolute',
    bottom: 88,
    right: 37,
    zIndex: 100
  },
  scrollContainer: {
    height: '100%',
  }
};

export default styles;
